/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceDiscountTypes = {
    Flight: 'Flight',
    Train: 'Train',
    Bus: 'Bus',
    Hotel: 'Hotel',
    SuggestedService: 'SuggestedService',
    Taxi: 'Taxi',
    InternationalFlight: 'InternationalFlight',
    Bundle: 'Bundle'
} as const;

export type ServiceDiscountTypes = typeof ServiceDiscountTypes[keyof typeof ServiceDiscountTypes];



